import { ProductExportNotificationService } from './product-export-notification-service';
import { InventoryExportNotificationService } from './inventory-export-notification-service';
import { AutomationRulesNotificationService } from './automation-rules-notification-service';

class JobCompleteMessageServiceClass {
  constructor() {
    this.messageHandlers = [InventoryExportNotificationService, ProductExportNotificationService, AutomationRulesNotificationService];
  }

  processMessage(message) {
    const messageHandler = this.messageHandlers.find((handler) => handler.validateMessage(message));
    if (!messageHandler) {
      return;
    }

    messageHandler.processMessage(message);
  }

  isProductExportMessage(message) {
    const messageHandler = this.messageHandlers.find((handler) => handler.validateMessage(message));
    return messageHandler === ProductExportNotificationService;
  }

  isInventoryExportMessage(message) {
    const messageHandler = this.messageHandlers.find((handler) => handler.validateMessage(message));
    return messageHandler === InventoryExportNotificationService;
  }
}

export const JobCompleteMessageService = new JobCompleteMessageServiceClass();
